import React from "react";
// import { libreCaslon, jost } from './fonts';
import Header from "../components/header";
import Footer from "../components/footer";
// import GoogleAnalytics from "../components/GoogleAnalytics";
import "./globals.css";

export default function RootLayout({ children }) {
    // <GoogleAnalytics />
    return (
        <React.Fragment>
            <Header />
            <main>{children}</main>
            <Footer />
        </React.Fragment>
    );
}
